import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BoxConfirmDialogComponent, ProfileDeletionDialogComponent } from '@box-shared/components';
import { ConfirmDialogResponse, SeoOptions } from '@box-types';
import { DialogService, SEOService } from '@box-core/services';
import { ProfileDeletionDialogResponseResponse } from '@box-shared/components/profile-deletion-dialog/profile-deletion-dialog-data.types';
import { AccountContactService } from '../account-contact/account-contact.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'account-delete-profile',
  templateUrl: './account-delete-profile.page.html',
  styleUrls: ['./account-delete-profile.page.scss'],
  providers: [AccountContactService]
})
export class AccountDeleteProfilePage implements OnInit {
  constructor(
    private accountContactService: AccountContactService,
    private dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setMetaTags();
  }

  public initiateDeletionFlow(): void {
    this.showDeletionConfirmationDialog()
      .afterClosed()
      .subscribe((response: ConfirmDialogResponse) => {
        if (!response?.accepted) return;
        this.dialogService
          .openDialog(ProfileDeletionDialogComponent)
          .afterClosed()
          .subscribe((response: ProfileDeletionDialogResponseResponse) => {
            if (response?.success) this.accountContactService.onProfileDeletion();
          });
      });
  }

  private showDeletionConfirmationDialog(): MatDialogRef<BoxConfirmDialogComponent> {
    return this.dialogService.openConfirmDialog({
      title: 'delete_profile',
      messages: ['delete_profile_dialog_text_1', 'delete_profile_dialog_text_2', 'delete_profile_dialog_text_3'],
      cancelText: 'back_',
      confirmText: 'delete_'
    });
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
